import { getCurrentInstance } from 'vue';

export function useTranslation() {
    const vm = getCurrentInstance();

    return { t: (vm.proxy as any).$t as (key: string, param?: Record<string, string | number>) => string };
}
